export const insertOrReplace = <T extends { id: string | number }>(arrayOfObjects: T[] = [], item: T): T[] => {
  const a = [...arrayOfObjects];
  const i = a.findIndex((o) => o.id === item.id);
  i < 0 ? a.unshift(item) : a.splice(i, 1, item);

  return a;
};
